'use client';

import dynamic from 'next/dynamic';

/**
 * Client-side dynamic wrapper around `StickyHeader`. The header is
 * invisible at first paint (it slides in only after the user scrolls past
 * the hero), so there's no SEO/LCP benefit to server-rendering it.
 * `dynamic({ ssr: false })` defers its scroll listener + DOM walk off the
 * critical hydration pass. `loading: () => null` is fine because the header
 * is hidden by default.
 *
 * A separate `'use client'` file is required because `dynamic({ ssr:
 * false })` can't be called from the Server Component that renders it.
 */
const StickyHeader = dynamic(
  () => import('./StickyHeader').then(mod => ({ default: mod.StickyHeader })),
  { ssr: false, loading: () => null },
);

export { StickyHeader as LazyStickyHeader };
